import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_4 = { class: "dropdown-item" }
const _hoisted_5 = { class: "add-item" }

import { IntentListItemViewModel } from '@/features/bots/models/intents/intentListItemViewModel';
import AddIntentModal from '@/features/bots/components/designer/AddIntentModal.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import { IntentViewModel } from '@/features/bots/models/intents/intentViewModel';
import { required } from '@vuelidate/validators';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';
import { LOAD_INTENTS } from '@/store/intents/actionTypes';
import Toast from '@/shared/services/toast';
import { computed, nextTick, onMounted, PropType, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { useStore } from 'vuex';
import { TriggerConditionAttributeType } from '@/features/bots/components/designer/Conditions/useTriggerConditions';


export default /*@__PURE__*/_defineComponent({
  __name: 'IntentCondition',
  props: {
  condition: {
    type: Object as PropType<ConditionViewModel>,
    required: true,
  },
},
  emits: ["changed", "completed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const intents = computed<IntentListItemViewModel[]>(() => store.getters.intents);
const loadIntents = (forceLoad: boolean = false): Promise<IntentListItemViewModel[]> =>
  store.dispatch(LOAD_INTENTS, forceLoad);

const selectedIntentId = ref('');
const isLoading = ref(false);
const liveCondition = ref<ConditionViewModel>({
  attribute: TriggerConditionAttributeType.MessageIntent,
  operation: '',
  type: '',
  value: '',
  result: true,
});
const showAddIntentModel = ref(false);
const intentConditionAddModal = ref<typeof AddIntentModal | null>(null);

const intentsForFlows = computed(() => intents.value.filter((e) => e.id !== 'None'));

const validations = {
  liveCondition: {
    value: { required },
  },
};

const $v = useVuelidate(validations, { liveCondition });

onMounted(async () => {
  isLoading.value = true;
  try {
    await loadIntents();
  } catch {
    Toast.showError('Failed to load intents');
  }
  isLoading.value = false;

  if (props.condition) {
    liveCondition.value = {
      attribute: TriggerConditionAttributeType.MessageIntent,
      operation: 'equals',
      type: props.condition.type,
      value: props.condition.value,
      result: props.condition.result,
      unit: props.condition.unit,
      invalid: props.condition.invalid,
    };

    if (liveCondition.value.invalid) {
      $v.value.$touch();
    }
  }

  emitConditionChanged();
});

async function chooseIntent(intent: IntentListItemViewModel) {
  selectedIntentId.value = intent.id;
  chosenIntent();
}

function addNewIntent() {
  showAddIntentModel.value = true;
  nextTick(() => {
    if (intentConditionAddModal.value) {
      intentConditionAddModal.value.addNewIntent();
    }
  });
}

function addedIntent(intent: IntentViewModel) {
  selectedIntentId.value = intent.id;
  showAddIntentModel.value = false;
  chosenIntent();
}

function cancelled() {
  showAddIntentModel.value = false;
  complete();
}

function chosenIntent() {
  liveCondition.value.value = selectedIntentId.value;
  complete();
}

function emitConditionChanged() {
  liveCondition.value.invalid = $v.value.$invalid;
  emit('changed', liveCondition.value);
}

function complete() {
  liveCondition.value.invalid = $v.value.$invalid;
  emit('completed', liveCondition.value);
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intentsForFlows.value, (intent) => {
            return (_openBlock(), _createElementBlock("div", {
              key: intent.id,
              class: "intent-list"
            }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (chooseIntent(intent)),
                class: "dropdown-item"
              }, _toDisplayString(intent.title), 9, _hoisted_2)
            ]))
          }), 128)),
          (intentsForFlows.value.length > 0)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                class: "add-intent",
                onClick: addNewIntent
              }, [
                _createVNode(AddIcon, { class: "icon-1-3x" }),
                _cache[0] || (_cache[0] = _createTextVNode(" Add new intent ", -1))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showAddIntentModel.value)
      ? (_openBlock(), _createBlock(AddIntentModal, {
          key: 2,
          ref_key: "intentConditionAddModal",
          ref: intentConditionAddModal,
          onCompleted: addedIntent,
          onCancelled: cancelled
        }, null, 512))
      : _createCommentVNode("", true)
  ]))
}
}

})